const normalizeApiBaseUrl = (value?: string): string => {
  const trimmed = value?.trim();
  if (!trimmed) {
    return '';
  }

  return trimmed.replace(/\/+$/, '');
};

const explicitApiBaseUrl = normalizeApiBaseUrl(process.env.REACT_APP_API_URL);

// In local development, prefer relative /api URLs so the CRA proxy can forward
// requests when REACT_APP_API_URL is not explicitly set. In production, never
// fall back to localhost; same-origin requests are safer than pointing a user's
// browser at its own machine.
export const API_BASE_URL = explicitApiBaseUrl || '';

export const buildApiUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return API_BASE_URL ? `${API_BASE_URL}${normalizedPath}` : normalizedPath;
};
